var map = {
	"./symbol_0.png": "25ed",
	"./symbol_1.png": "5522",
	"./symbol_2.png": "ace3",
	"./symbol_3.png": "2186",
	"./symbol_4.png": "ce4c",
	"./symbol_5.png": "1d6e",
	"./symbol_6.png": "ec25",
	"./symbol_7.png": "9ac4",
	"./symbol_8.png": "23ab",
	"./symbol_9.png": "4f11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bbe";